
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import formatters from "@/utils/ColumnFormater";
import OrderDetail from "@/views/order/subviews/OrderDetail.vue";
import { API_ORDER_GETORDER } from "@/configs/Apis";
import {
  isEmptyOrWhiteSpace,
  showWarning
} from "@/utils/Common";

@Component({ components: { OrderDetail } })
export default class PatentDetail extends Vue {
  @Prop({ type: String, default: () => "{}" })
  data!: string;

  showOrder = false;

  orderDetail: any = {};

  @Prop({ type: Boolean, default: () => false })
  showGoNext!: boolean;

  @Prop({ type: Boolean, default: () => false })
  showGoPrev!: boolean;

  @Inject()
  getModuleName!: () => string;

  collapseInfo = true;

  currentFeePage = 1;
  feePageSize = 5;

  currentPaidFeePage = 1;
  paidFeePageSize = 5;

  currentLateFeePage = 1;
  lateFeePageSize = 5;

  handleCurrentFeeChange(page: number) {
    this.currentFeePage = page;
  }
  handleCurrentPaidFeeChange(page: number) {
    this.currentPaidFeePage = page;
  }
  handleCurrentLateFeeChange(page: number) {
    this.currentLateFeePage = page;
  }

  get patentDetail() {
    const patentDetail = JSON.parse(this.data);
    patentDetail.patentFeeList = patentDetail.patentFeeList || [];
    patentDetail.patentPaidFeeList = patentDetail.patentPaidFeeList || [];
    patentDetail.patentLateFeeList = patentDetail.patentLateFeeList || [];
    return patentDetail;
  }

  get colFormatters() {
    return formatters;
  }

  onOrderDetailClick(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.showOrder = true;
    this.$store.dispatch(`${this.getModuleName()}/get`, { api: `${API_ORDER_GETORDER}/${data.feeOrderId}` }).then(data => {
      if (data) {
        this.orderDetail = data;
      }
    });
  }

  goNext() {
    this.$emit("next-item");
  }

  goPrev() {
    this.$emit("prev-item");
  }

  openCnipaLink() {
    if (isEmptyOrWhiteSpace(this.patentDetail.pubNo)) {
      showWarning("目前只支持查看已公开专利");
      return;
    }
    window.open("http://epub.cnipa.gov.cn/patent/" + this.patentDetail.pubNo);
    // window.open("http://epub.cnipa.gov.cn/tdcdesc.action?strWhere=CN" + this.patentDetail.pubNo);
  }

  openEspacenetLink() {
    if (isEmptyOrWhiteSpace(this.patentDetail.pubNo)) {
      showWarning("目前只支持查看已公开专利");
      return;
    }
    window.open("https://worldwide.espacenet.com/publicationDetails/biblio?CC=CN&NR=" + this.patentDetail.pubNo + "&FT=D&locale=cn_EP");
  }
}
